module.exports = "/_next/static/images/p_sq-b94eabf72d8f4e2cb2920c16d2a30eb2.png";